var $ = require('jquery')
  , detector = require('widgets/detector')

module.exports = function () {
  var dfd = new $.Deferred()

  dfd[detector.isWexinQQBrowser() ? 'resolve': 'reject']
    .apply(this, arguments)

  return dfd.promise()
}
